'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Table", {
    enumerable: true,
    get: function() {
        return Table;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTable = require("./useTable");
const _renderTable = require("./renderTable");
const _useTableStylesstyles = require("./useTableStyles.styles");
const _useTableContextValues = require("./useTableContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Table = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTable.useTable_unstable)(props, ref);
    (0, _useTableStylesstyles.useTableStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableStyles_unstable')(state);
    return (0, _renderTable.renderTable_unstable)(state, (0, _useTableContextValues.useTableContextValues_unstable)(state));
});
Table.displayName = 'Table';
